import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AdminService } from '@services/admin.service';
import { DialogService } from '@services/dialog.service';
import { ErrorService } from '@services/error.service';

import { PdfCatalog } from '@models/pdf-catalog';

@Component({
  selector: 'app-pdf-catalogs',
  templateUrl: './pdf-catalogs.component.html',
  styleUrl: './pdf-catalogs.component.scss',
  standalone: false,
})
export class PdfCatalogsComponent implements OnInit, OnDestroy {

  public file: File | null = null;
  public fileUploading: boolean = false;
  public uploadForm: FormGroup;
  public loadingPdfCatalogs: boolean = true;
  public pdfCatalogs!: PdfCatalog[];
  private interval: any;

  @ViewChild("formFile") inputVar: ElementRef | undefined;

  constructor(
    private modalService: NgbModal,
    private adminService: AdminService,
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private errorService: ErrorService,
  ) {
    this.uploadForm = this.formBuilder.group({
      relations_description: ['show',
        Validators.compose([Validators.required])
      ],
      keyword_source: ['schlagwort',
        Validators.compose([Validators.required])
      ],
      page_keywords: ['show',
        Validators.compose([Validators.required])
      ],
    });
  }

  ngOnInit(): void {
    this.loadPdfCatalogs();

    this.interval = setInterval(() => {
      this.loadPdfCatalogs();
    }, 3000);
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  public onFileSelected(event: any) {
    this.file = event.target.files[0];
  }

  public refreshPdfCatalogs() {
    this.loadingPdfCatalogs = true;
    this.loadPdfCatalogs();
  }

  private loadPdfCatalogs() {
    this.adminService.getPdfCatalogs().then((result: PdfCatalog[]) => {
      this.pdfCatalogs = result;
      this.loadingPdfCatalogs = false;
    });
  }

  public postFile() {
    let file = this.file;
    if (file) {
      this.fileUploading = true;

      this.dialogService.showLoader("pdfCatalogUpload", "Datei wird hochgeladen...");

      this.adminService.uploadPdfCatalogSource(file, this.uploadForm.value).then(() => {
        this.dialogService.dismissLoader("pdfCatalogUpload");
        this.file = null;
        this.fileUploading = false;

        this.dialogService.alert(null, "Die Datei wurde erfolgreich hochgeladen und wird nun verarbeitet. Du erhältst eine E-Mail, wenn die Verarbeitung abgeschlossen ist.");

        if (this.inputVar) {
          this.inputVar.nativeElement.value = "";
        }

        this.loadPdfCatalogs();
      }).catch((err: any) => {
        this.errorService.printError(err);
        this.fileUploading = false;
        this.dialogService.dismissLoader("pdfCatalogUpload");

        this.dialogService.alert(null, "Beim Hochladen der Datei ist ein Fehler aufgetreten.", 'danger', 0);
      });
    }
  }


  public showMessages(modal: TemplateRef<any>) {
    this.modalService.open(modal, {
      size: 'lg',
      centered: true,
    });
  }

}
